import { ContentLayoutProvider } from '@/contexts/ContentLayoutContext'
import { transformImage, transformVideo } from '@/helpers/transforms'
import type { FullWidthImageBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { hasText } from '@payloadcms/richtext-lexical/shared'
import { CMSBlocks } from '../atoms/CMSBlocks'
import FeatureImageTextBlock from '../blocks/FeatureImageTextBlock'

export const FullWidthImageConverter: JSXConverter<SerializedBlockNode<FullWidthImageBlock>> = ({
	node,
	nodesToJSX,
}) => {
	const { mediaType, image, video, caption } = node.fields

	const hasCaption = hasText(caption)

	const imageData = transformImage(image)

	const videoData = transformVideo(video)

	return (
		<FeatureImageTextBlock
			mediaType={mediaType}
			image={imageData}
			video={videoData}
			hasCaption={hasCaption}
		>
			<ContentLayoutProvider layout="nested">
				<CMSBlocks>{nodesToJSX({ nodes: caption?.root?.children ?? [] })}</CMSBlocks>
			</ContentLayoutProvider>
		</FeatureImageTextBlock>
	)
}

export default FullWidthImageConverter
